
export default {
    namespaced: true,
    state: {
        dialog: false,
        usuario: {},
        usuarios: [],
        gruposUsuario: [],
        color: '',
        editandoUsuario: ''
    },
    mutations: {
        SET_DIALOG(state, mostrar){
            state.dialog = mostrar
        },
        SET_USUARIOS(state, respuesta){
            state.usuarios = [];
            let usuarios = [];
            respuesta.data.forEach(usuario => {
                let estado = usuario.habilitado ? 'Habilitado' : 'Deshabilitado';
                usuarios.push({
                    id: usuario.id,
                    nombre: usuario.name,
                    apellidos: usuario.apellidos,
                    email: usuario.email,
                    created_at: usuario.created_at,
                    habilitado: usuario.habilitado,
                    observaciones: usuario.observaciones,
                    isAdmin: usuario.isAdmin,
                    estado: estado
                });
            });
            state.usuarios = usuarios;
        },
        SET_USUARIO(state, usuario){
            state.usuario = usuario;
            state.editandoUsuario = true;
            //console.log(state.usuario);
        },
        SET_NUEVOUSUARIO(state){
            state.editandoUsuario = false;
            let colores = ['teal', 'pink darken-1', 'purple darken-1', 'deep-purple darken-1', 'indigo darken-1', 'blue darken-1', 'light-blue darken-1', 'cyan darken-1', 'teal', 'green darken-1', 'orange darken-1', 'brown darken-1', 'blue-grey darken-1', 'red darken-1'];
            state.usuario = {
                name: '',
                apellidos: '',
                email: '',
                password: '',
                avatar: 'NU',
                color: colores[Math.floor(Math.random() * colores.length)],
                habilitado: 1,
                observaciones: '',
                isAdmin: 0,
                habilitado: 1
            }
        },
        
    },
    actions: {
        setDialog({commit}, mostrar){
            commit('SET_DIALOG', mostrar);
        },
        setUsuario({commit}, usuario){
            commit('SET_USUARIO', usuario);
        },
        setUsuarios({commit}, respuesta){
            commit('SET_USUARIOS', respuesta);
        },
        setNuevoUsuario({commit}){
            commit('SET_NUEVOUSUARIO');
        },
    }
}